import { useState, useEffect } from "react";
import { uid, T, mono } from "./utils";
import { supabase } from "./supabase";

function toDateStr(date) {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,"0")}-${String(date.getDate()).padStart(2,"0")}`;
}
function getWeekDays() {
  const now=new Date(); const dow=(now.getDay()+6)%7;
  const mon=new Date(now); mon.setDate(now.getDate()-dow); mon.setHours(0,0,0,0);
  const DAYS=["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"];
  return Array.from({length:7},(_,i)=>{
    const d=new Date(mon); d.setDate(mon.getDate()+i);
    return {label:`${d.getDate()} ${DAYS[i]}`, dateStr:toDateStr(d)};
  });
}

const ETC_BLUE = "#4a6fa5";

export function EtcView() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newProjTitle, setNewProjTitle] = useState("");
  const [adding, setAdding] = useState(false);

  useEffect(() => { loadProjects(); }, []);

  async function loadProjects() {
    setLoading(true);
    const { data } = await supabase
      .from("projects")
      .select("*, tasks(*)")
      .eq("kind", "etc")
      .order("created_at");
    setProjects((data || []).map(p => ({
      id: p.id,
      title: p.title,
      notes: p.notes || "",
      tasks: (p.tasks || [])
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        .map(t => ({ id: t.id, text: t.text, done: t.done, dueDate: t.due_date || "" }))
    })));
    setLoading(false);
  }

  async function addProject() {
    if (!newProjTitle.trim()) return;
    const id = uid();
    const np = { id, title: newProjTitle.trim(), notes: "", tasks: [] };
    setProjects(p => [...p, np]);
    setNewProjTitle(""); setAdding(false);
    await supabase.from("projects").insert({
      id, title: np.title, director: "", dir_email: "", producer: "",
      producer_email: "", type: "—", phase: "Aktif", flags: "", status: "Aktif",
      note: "", notes: "", drive_url: "", kind: "etc"
    });
  }

  async function deleteProject(id) {
    if (!window.confirm("Bu projeyi silmek istediğine emin misin?")) return;
    setProjects(p => p.filter(x => x.id !== id));
    await supabase.from("tasks").delete().eq("project_id", id);
    await supabase.from("projects").delete().eq("id", id);
  }

  async function updateTitle(id, title) {
    setProjects(p => p.map(x => x.id === id ? { ...x, title } : x));
    await supabase.from("projects").update({ title }).eq("id", id);
  }

  async function updateNotes(id, notes) {
    setProjects(p => p.map(x => x.id === id ? { ...x, notes } : x));
    await supabase.from("projects").update({ notes }).eq("id", id);
  }

  async function addTask(projId, text, dueDate) {
    if (!text.trim()) return;
    const t = { id: uid(), text: text.trim(), done: false, dueDate: dueDate || "" };
    setProjects(p => p.map(x => x.id === projId ? { ...x, tasks: [...x.tasks, t] } : x));
    await supabase.from("tasks").insert({
      id: t.id, project_id: projId, text: t.text,
      done: false, due_date: t.dueDate || null, etc: false
    });
  }

  async function toggleTask(projId, taskId) {
    const proj = projects.find(x => x.id === projId);
    const task = proj?.tasks.find(t => t.id === taskId);
    if (!task) return;
    setProjects(p => p.map(x => x.id === projId ? {
      ...x, tasks: x.tasks.map(t => t.id === taskId ? { ...t, done: !t.done } : t)
    } : x));
    await supabase.from("tasks").update({ done: !task.done }).eq("id", taskId);
  }

  async function removeTask(projId, taskId) {
    setProjects(p => p.map(x => x.id === projId ? {
      ...x, tasks: x.tasks.filter(t => t.id !== taskId)
    } : x));
    await supabase.from("tasks").delete().eq("id", taskId);
  }

  async function assignDay(projId, taskId, dateStr) {
    setProjects(p => p.map(x => x.id === projId ? {
      ...x, tasks: x.tasks.map(t => t.id === taskId ? { ...t, dueDate: dateStr } : t)
    } : x));
    await supabase.from("tasks").update({ due_date: dateStr || null }).eq("id", taskId);
  }

  if (loading) return (
    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span style={{ ...mono, color: T.mute }}>Loading</span>
    </div>
  );

  return (
    <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden", padding: "32px 40px" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 28, paddingBottom: 14, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ ...mono, fontSize: 9, color: T.mute, marginBottom: 4 }}>ETC.</div>
          <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.02em" }}>Diğer Projeler</div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {adding ? (
            <>
              <input value={newProjTitle} onChange={e => setNewProjTitle(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter") addProject(); if (e.key === "Escape") { setAdding(false); setNewProjTitle(""); } }}
                autoFocus placeholder="Proje adı…"
                style={{ background: "#fff", border: `1px solid ${T.accent}`, borderRadius: 2, padding: "6px 12px", fontSize: 13, fontFamily: "'Inter',sans-serif", width: 200, outline: "none" }} />
              <button onClick={addProject} style={{ background: T.ink, color: "#fff", border: "none", borderRadius: 2, padding: "6px 14px", fontSize: 12, cursor: "pointer", fontWeight: 500 }}>Ekle</button>
              <button onClick={() => { setAdding(false); setNewProjTitle(""); }} style={{ background: "none", border: `1px solid ${T.border}`, borderRadius: 2, padding: "6px 12px", fontSize: 12, cursor: "pointer", color: T.mute }}>İptal</button>
            </>
          ) : (
            <button onClick={() => setAdding(true)} style={{ background: T.ink, color: "#fff", border: "none", borderRadius: 2, padding: "7px 16px", fontSize: 12, cursor: "pointer", fontWeight: 500 }}>+ Proje Ekle</button>
          )}
        </div>
      </div>

      {projects.length === 0 && (
        <div style={{ padding: "60px 0", textAlign: "center", ...mono, color: T.mute }}>
          Henüz proje yok. "+ Proje Ekle" ile başla.
        </div>
      )}

      {/* Project cards grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
        {projects.map(proj => (
          <EtcCard
            key={proj.id}
            proj={proj}
            onDelete={() => deleteProject(proj.id)}
            onTitleChange={v => updateTitle(proj.id, v)}
            onNotesChange={v => updateNotes(proj.id, v)}
            onAddTask={(text, due) => addTask(proj.id, text, due)}
            onToggleTask={tid => toggleTask(proj.id, tid)}
            onRemoveTask={tid => removeTask(proj.id, tid)}
            onAssignDay={(tid, date) => assignDay(proj.id, tid, date)}
          />
        ))}
      </div>
    </div>
  );
}

function EtcCard({ proj, onDelete, onTitleChange, onNotesChange, onAddTask, onToggleTask, onRemoveTask, onAssignDay }) {
  const [newTask, setNewTask] = useState("");
  const [newDue, setNewDue] = useState("");
  const [assigningId, setAssigningId] = useState(null);
  const [editingTitle, setEditingTitle] = useState(false);
  const [titleVal, setTitleVal] = useState(proj.title);
  const [showDone, setShowDone] = useState(false);
  const weekDays = getWeekDays();
  const pending = proj.tasks.filter(t => !t.done);
  const doneTasks = proj.tasks.filter(t => t.done);
  const done = doneTasks.length;

  const commitTitle = () => {
    setEditingTitle(false);
    if (titleVal.trim() && titleVal.trim() !== proj.title) onTitleChange(titleVal.trim());
  };

  const handleAdd = () => {
    if (!newTask.trim()) return;
    onAddTask(newTask, newDue);
    setNewTask(""); setNewDue("");
  };

  return (
    <div style={{ background: "#fff", border: `1px solid ${T.border}`, borderLeft: `3px solid ${ETC_BLUE}`, borderRadius: 4, padding: "12px", display: "flex", flexDirection: "column", gap: 9, minWidth: 0 }}>

      {/* Card header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          {editingTitle ? (
            <input value={titleVal} onChange={e => setTitleVal(e.target.value)}
              onBlur={commitTitle} onKeyDown={e => { if (e.key === "Enter") commitTitle(); if (e.key === "Escape") { setTitleVal(proj.title); setEditingTitle(false); } }}
              autoFocus style={{ fontSize: 15, fontWeight: 600, color: ETC_BLUE, border: `1px solid ${T.accent}`, borderRadius: 2, padding: "1px 6px", fontFamily: "'Inter',sans-serif", width: "100%", outline: "none" }} />
          ) : (
            <div onClick={() => setEditingTitle(true)} title="Düzenlemek için tıkla"
              style={{ fontSize: 15, fontWeight: 600, color: ETC_BLUE, cursor: "text", letterSpacing: "-0.01em", borderBottom: `1px dashed ${T.border}` }}>
              {proj.title}
            </div>
          )}
          {proj.tasks.length > 0 && (
            <div style={{ ...mono, fontSize: 9, color: T.mute, marginTop: 4 }}>{done}/{proj.tasks.length} tamamlandı</div>
          )}
        </div>
        <button onClick={onDelete} style={{ background: "none", border: "none", color: T.mute, fontSize: 13, cursor: "pointer", padding: "0 0 0 8px", opacity: 0.4, flexShrink: 0 }}
          onMouseEnter={e => e.currentTarget.style.opacity = "1"} onMouseLeave={e => e.currentTarget.style.opacity = "0.4"}>×</button>
      </div>

      {/* Notes */}
      <textarea value={proj.notes} onChange={e => onNotesChange(e.target.value)} placeholder="Notlar…"
        onMouseUp={e=>{const h=e.target.style.height;if(h)localStorage.setItem("etc_note_h_"+proj.id,h);}}
        style={{ width: "100%", height: localStorage.getItem("etc_note_h_"+proj.id)||"48px", background: T.bg, border: `1px solid ${T.border}`, borderRadius: 2, padding: "6px 8px", fontSize: 11, fontFamily: "'Inter',sans-serif", resize: "vertical", lineHeight: 1.5, color: T.ink, outline: "none" }} />

      {/* Tasks */}
      <div>
        {proj.tasks.length === 0 && (
          <div style={{ ...mono, fontSize: 9, color: T.mute, marginBottom: 6 }}>Henüz görev yok.</div>
        )}
        {pending.map(t => (
          <div key={t.id} style={{ borderBottom: `1px solid ${T.borderLight}` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "6px 0", minWidth: 0 }}
              onMouseEnter={e => { e.currentTarget.querySelector(".trm").style.opacity = "1"; e.currentTarget.querySelector(".tday").style.opacity = "1"; }}
              onMouseLeave={e => { e.currentTarget.querySelector(".trm").style.opacity = "0"; e.currentTarget.querySelector(".tday").style.opacity = "0"; }}>
              <div onClick={() => onToggleTask(t.id)} style={{ width: 13, height: 13, borderRadius: 2, flexShrink: 0, cursor: "pointer", background: t.done ? T.ink : "transparent", border: `1.5px solid ${t.done ? T.ink : T.border}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                {t.done && <span style={{ color: "#fff", fontSize: 8 }}>✓</span>}
              </div>
              <span style={{ flex: 1, minWidth: 0, fontSize: 12, color: t.done ? T.mute : T.ink, textDecoration: t.done ? "line-through" : "none", lineHeight: 1.3, overflowWrap: "anywhere", wordBreak: "break-word" }}>{t.text}</span>
              {t.dueDate && <span style={{ ...mono, fontSize: 8, color: ETC_BLUE, flexShrink: 0 }}>{t.dueDate.slice(5)}</span>}
              {!t.done && (
                <button className="tday" onClick={() => setAssigningId(assigningId === t.id ? null : t.id)}
                  style={{ opacity: 0, ...mono, fontSize: 8, background: "none", border: `1px solid ${T.border}`, borderRadius: 2, padding: "1px 5px", cursor: "pointer", color: T.mute, transition: "opacity .15s", flexShrink: 0 }}>
                  gün
                </button>
              )}
              <button className="trm" onClick={() => onRemoveTask(t.id)}
                style={{ opacity: 0, background: "none", border: "none", color: "#c0392b", fontSize: 13, cursor: "pointer", padding: 0, transition: "opacity .15s" }}>×</button>
            </div>
            {/* Day picker */}
            {assigningId === t.id && (
              <div style={{ display: "flex", gap: 3, flexWrap: "wrap", padding: "3px 0 7px 20px" }}>
                {weekDays.map(wd => (
                  <span key={wd.dateStr} onClick={() => { onAssignDay(t.id, wd.dateStr); setAssigningId(null); }}
                    style={{ ...mono, fontSize: 8, padding: "3px 6px", borderRadius: 2, background: t.dueDate === wd.dateStr ? ETC_BLUE : T.bg, color: t.dueDate === wd.dateStr ? "#fff" : T.mute, cursor: "pointer", border: `1px solid ${t.dueDate === wd.dateStr ? ETC_BLUE : T.border}` }}>
                    {wd.label}
                  </span>
                ))}
                {t.dueDate && (
                  <span onClick={() => { onAssignDay(t.id, ""); setAssigningId(null); }}
                    style={{ ...mono, fontSize: 8, padding: "3px 6px", borderRadius: 2, background: T.bg, color: "#c0392b", cursor: "pointer", border: "1px solid #fcc" }}>kaldır</span>
                )}
              </div>
            )}
          </div>
        ))}

        {/* Bitmiş görevler — varsayılan gizli, sütun uzamasın */}
        {done > 0 && (
          <div onClick={() => setShowDone(s => !s)} style={{ ...mono, fontSize: 9, color: T.border, cursor: "pointer", padding: "6px 0" }}>
            {showDone ? "gizle" : `+ ${done} tamamlanan`}
          </div>
        )}
        {showDone && doneTasks.map(t => (
          <div key={t.id} style={{ borderBottom: `1px solid ${T.borderLight}` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "6px 0", minWidth: 0 }}
              onMouseEnter={e => { e.currentTarget.querySelector(".trm").style.opacity = "1"; }}
              onMouseLeave={e => { e.currentTarget.querySelector(".trm").style.opacity = "0"; }}>
              <div onClick={() => onToggleTask(t.id)} style={{ width: 13, height: 13, borderRadius: 2, flexShrink: 0, cursor: "pointer", background: T.ink, border: `1.5px solid ${T.ink}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ color: "#fff", fontSize: 8 }}>✓</span>
              </div>
              <span style={{ flex: 1, minWidth: 0, fontSize: 12, color: T.mute, textDecoration: "line-through", lineHeight: 1.3, overflowWrap: "anywhere", wordBreak: "break-word" }}>{t.text}</span>
              {t.dueDate && <span style={{ ...mono, fontSize: 8, color: T.mute, flexShrink: 0 }}>{t.dueDate.slice(5)}</span>}
              <button className="trm" onClick={() => onRemoveTask(t.id)}
                style={{ opacity: 0, background: "none", border: "none", color: "#c0392b", fontSize: 13, cursor: "pointer", padding: 0, transition: "opacity .15s" }}>×</button>
            </div>
          </div>
        ))}

        {/* Add task */}
        <div style={{ marginTop: 8, display: "flex", gap: 5, alignItems: "center", flexWrap: "wrap" }}>
          <input value={newTask} onChange={e => setNewTask(e.target.value)} onKeyDown={e => e.key === "Enter" && handleAdd()}
            placeholder="Görev ekle…"
            style={{ flex: "1 1 100px", minWidth: 0, background: T.bg, border: `1px solid ${T.border}`, borderRadius: 2, padding: "5px 8px", fontSize: 11, fontFamily: "'Inter',sans-serif", boxSizing: "border-box" }} />
          <input type="date" value={newDue} onChange={e => setNewDue(e.target.value)}
            style={{ flex: "0 1 100px", minWidth: 0, background: T.bg, border: `1px solid ${T.border}`, borderRadius: 2, padding: "5px 6px", fontSize: 10, fontFamily: "'Inter',sans-serif", color: newDue ? T.ink : T.mute, boxSizing: "border-box" }} />
          <button onClick={handleAdd} style={{ background: ETC_BLUE, color: "#fff", border: "none", borderRadius: 2, padding: "5px 10px", fontSize: 13, cursor: "pointer", flexShrink: 0, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}>+</button>
        </div>
        {newDue && <div style={{ ...mono, fontSize: 8, color: ETC_BLUE, marginTop: 3 }}>Anasayfada o günün listesinde görünür (mavi).</div>}
      </div>
    </div>
  );
}
